import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";

import { ApplicationState } from "../../../redux/ApplicationState";
import { NtuPatientPayload } from "../../../models/Referral";
import {
  getMasterNtuReason,
  postNtuPatient,
} from "../../../actions/ReferralAction";
import NtuPatient from "../components/NtuPatient";
import { getListResult } from "../../../utils";

const mapStateToProps = ({masterNtuReasonState}: ApplicationState) => ({
    masterNtuReasonState: getListResult(masterNtuReasonState.response)
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<ApplicationState, Record<string, never>, any>
) => {
  return {
    postNtuPatient: (payload: NtuPatientPayload) => {
      dispatch(postNtuPatient(payload));
    },
    getMasterNtuReason: (typeId: boolean) => {
      dispatch(getMasterNtuReason(typeId));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NtuPatient);
